import { Expose, Type } from 'class-transformer'
import { UserTypeComment } from './UserTypeComment'

class ParentUserType {
  @Expose() id: number

  @Expose() profilePageSlug: string
}

class ParentCommentType {
  @Expose()
  @Type(() => ParentUserType)
  user: ParentUserType
}

class ChapterType {
  @Expose() chapterName: string
}

class RepliedType {
  @Expose() id: number

  @Expose()
  @Type(() => ParentUserType)
  user: ParentUserType
}

class UpdatedByType {
  @Expose() id: number
}

export class CommentType {
  @Expose() id: number

  @Expose() content: string

  @Expose()
  @Type(() => CommentType)
  childrenComment: CommentType[]

  @Expose()
  @Type(() => ParentCommentType)
  parentComment: ParentCommentType

  @Expose() likeCount: number

  @Expose() isLiked: boolean

  @Expose()
  @Type(() => UserTypeComment)
  user: UserTypeComment

  @Expose()
  @Type(() => ChapterType)
  bookChapter: ChapterType

  @Expose() visible: boolean

  @Expose()
  @Type(() => RepliedType)
  replied: RepliedType

  @Expose() createdAt: string

  @Expose()
  @Type(() => UpdatedByType)
  updatedBy: UpdatedByType
}
